import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "layout__wrapper-inner container"
}
const _hoisted_2 = {
  key: 1,
  class: "layout__wrapper-inner container"
}
const _hoisted_3 = { class: "help__subtitle" }
const _hoisted_4 = { class: "alert alert-success" }
const _hoisted_5 = {
  id: "support-edit-form-group-subject",
  class: "form__group"
}
const _hoisted_6 = {
  tabindex: "-1",
  role: "group"
}
const _hoisted_7 = {
  id: "support-edit-form-group-body",
  class: "form__group"
}
const _hoisted_8 = {
  tabindex: "-1",
  role: "group"
}
const _hoisted_9 = {
  key: 0,
  class: "invalid-feedback error-body"
}
const _hoisted_10 = { class: "form__btns-wrapper" }
const _hoisted_11 = {
  type: "submit",
  class: "btns"
}
const _hoisted_12 = {
  class: "help__version",
  href: "javascript:window.location.reload()"
}

import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useWait } from '@/app/composables/useWait'

import RootPageLayout from '@/app/components/RootPageLayout.vue'
import ContentWrapper from '@/components/ui/ContentWrapper.vue'
import FormError from '@/components/ui/FormError.vue'
import ButtonSpinner from '@/components/ui/ButtonSpinner.vue'
import InputWithContextMenu from '@/app/components/InputWithContextMenu.vue'
import SupportFAQ from '@/app/components/faq/SupportFAQ.vue'

import { APP_VERSION } from '@/init/settings'
import { ValidationState, setInputFocusStart } from '@/helpers/form'
import { offline } from '@/services/offline'
import { backend } from '@/services/backend'
import { platform } from '@/services/platform'
import { processDevCommands } from '@/services/commands'
import { scrollIntoView } from '@/helpers/dom'


export default /*@__PURE__*/_defineComponent({
  __name: 'Help',
  setup(__props) {

const router = useRouter()
const wait = useWait()

const subjectInput = ref<InstanceType<typeof InputWithContextMenu> | null>(null)

const validation = ref(new ValidationState())
const redirectDelay = ref(2000)

const sentAlert = ref(false)
const subject = ref('')
const body = ref('')

onMounted(async () => {
  if (offline.isOnline) {
    const input = subjectInput.value?.$el
    setInputFocusStart(input)

    const info = await platform.deviceInfo()
    if (window.__UNIT_TESTING !== true) {
      console.log(info)
    }
  }
  processDevCommands()
})

async function send(): Promise<void> {
  try {
    wait.start('Sending')
    await backend.sendSupportRequest(subject.value, body.value)
    validation.value.reset()

    // Show subscribed alert and redirect to books page after delay.
    sentAlert.value = true

    setTimeout(() => {
      wait.end('Sending')
      router.push({ name: 'discover' })
    }, redirectDelay.value)
  } catch (error) {
    validation.value.showErrors(error)
    wait.end('Sending')
  }
}

function isOffline(): boolean {
  return offline.isOffline
}

function scrollToFaq(): void {
  scrollIntoView('#faq', { behaviour: 'smooth' })
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_v_wait = _resolveComponent("v-wait")!
  const _directive_wait = _resolveDirective("wait")!

  return (_openBlock(), _createBlock(RootPageLayout, {
    id: "support",
    class: "help",
    title: "Support Request and FAQ",
    mobileTitle: "Support"
  }, {
    default: _withCtx(() => [
      (isOffline())
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(ContentWrapper, null, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createElementVNode("p", null, " It looks like you’re offline. Please connect to the Internet and try again. ", -1),
                _createElementVNode("p", null, [
                  _createTextVNode(" Alternatively, you can send us an email directly at "),
                  _createElementVNode("a", { href: "mailto:help@shortform.com" }, "help@shortform.com"),
                  _createTextVNode(". ")
                ], -1)
              ]))]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[4] || (_cache[4] = _createTextVNode(" Check our ", -1)),
              _createVNode(_component_RouterLink, {
                to: "/app/help#faq",
                class: "help__faq-link",
                onClick: scrollToFaq
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode(" FAQ below ", -1)
                ]))]),
                _: 1
              }),
              _cache[5] || (_cache[5] = _createTextVNode(" for common questions and solutions.", -1)),
              _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
              _cache[7] || (_cache[7] = _createTextVNode(" Didn’t find an answer to your question? Fill out the form below, or send us an email directly at ", -1)),
              _cache[8] || (_cache[8] = _createElementVNode("a", { href: "mailto:help@shortform.com" }, "help@shortform.com", -1))
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_4, " Successfully sent a request. ", 512), [
              [_vShow, sentAlert.value]
            ]),
            _createElementVNode("form", {
              role: "form",
              class: "form",
              novalidate: "",
              onSubmit: _withModifiers(send, ["prevent"])
            }, [
              _createElementVNode("fieldset", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form__label form__label--large" }, " Subject ", -1)),
                  _createVNode(InputWithContextMenu, {
                    id: "support-edit-subject",
                    ref_key: "subjectInput",
                    ref: subjectInput,
                    modelValue: subject.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((subject).value = $event)),
                    placeholder: "Enter subject here",
                    type: "text",
                    class: _normalizeClass([validation.value.stateClass('subject'), "form-control"])
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode(FormError, {
                    errors: validation.value.errors,
                    field: "subject"
                  }, null, 8, ["errors"])
                ])
              ]),
              _createElementVNode("fieldset", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form__label form__label--large" }, "Message", -1)),
                  _createVNode(InputWithContextMenu, {
                    id: "support-edit-body",
                    ref: "bodyTextarea",
                    modelValue: body.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((body).value = $event)),
                    elementType: "textarea",
                    placeholder: "How can we help?",
                    rows: "8",
                    type: "text",
                    class: _normalizeClass([validation.value.stateClass('body'), "form-control"])
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode(FormError, {
                    errors: validation.value.errors,
                    field: "body"
                  }, null, 8, ["errors"])
                ])
              ]),
              (validation.value.errors && validation.value.errors._schema)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, " {validation.errors._schema} "))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_11, [
                  _createVNode(_component_v_wait, { for: "Sending" }, {
                    waiting: _withCtx(() => [
                      _cache[11] || (_cache[11] = _createTextVNode(" Sending ", -1)),
                      _createVNode(ButtonSpinner)
                    ]),
                    default: _withCtx(() => [
                      _cache[12] || (_cache[12] = _createTextVNode(" Send request ", -1))
                    ]),
                    _: 1
                  })
                ])), [
                  [_directive_wait, 'Sending', "disabled"]
                ]),
                _createElementVNode("a", _hoisted_12, " Version " + _toDisplayString(_unref(APP_VERSION)), 1)
              ])
            ], 32)
          ])),
      _createVNode(SupportFAQ, { id: "faq" })
    ]),
    _: 1
  }))
}
}

})